<template>
  <div class="competencies-input"
    :uk-tooltip="disabled ? 'title: ' + $t('general.cannot_edit_started_training') : false">
    <app-multiselect v-model="selectedCompetencies" :allow-empty="true" :is-multiple="true" :options="competencies"
      :placeholder="$t('general.choose')" label="name" track-by="id" :loading="loading" :is-disabled="disabled"
      @input="handleSelectionChange" />
  </div>
</template>

<script>
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import axios from "axios";

export default {
  name: "CompetenciesInput",
  components: {
    AppMultiselect
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    perPage: {
      type: Number,
      default: 100
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      competencies: [],
      selectedCompetencies: []
    };
  },

  watch: {
    value: {
      handler(newValue) {
        this.selectedCompetencies = newValue;
      },
      immediate: true
    }
  },

  async mounted() {
    await this.loadCompetencies();
  },

  methods: {
    async loadCompetencies() {
      this.loading = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND_APP_URL}/api/competencies`, {
          params: { perPage: this.perPage },
        });

        this.competencies = response.data?.data || [];
      } catch (error) {
        console.error('Yetkinlikler yüklenirken hata:', error);
        this.competencies = [];
      } finally {
        this.loading = false;
      }
    },

    handleSelectionChange(selectedCompetencies) {
      this.selectedCompetencies = selectedCompetencies;
      this.$emit('input', selectedCompetencies);
      this.$emit('change', selectedCompetencies);
    },

    // Public method to refresh competencies
    async refreshCompetencies() {
      await this.loadCompetencies();
    }
  }
};
</script>

<style scoped>
.competencies-input {
  width: 100%;
}
</style>
